import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  useTheme,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { Document, PDFViewer, Page, View } from '@react-pdf/renderer';
import * as React from 'react';
import * as Redux from 'react-redux';
import Modal from '../../../../widgets/modals/Modal';
import { stylesDocPdf } from '../../../pdfs';
import HeaderPdf from '../../../pdfs/HeaderPdf';
import TablaReportesEstudiantes from './TablaReporteEstudiantes';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const styles = {
  pdfViewer: {
    width: '100%',
    height: '80vh',
    zIndex: 50,
  },
  section: {
    flex: 1,
    ...stylesDocPdf.section,
    margin: '20pt',
  },
};

export const columnsReportesEstudiantes = [
  {
    id: 'dni',
    name: 'Cédula',
  },
  {
    id: 'fullname',
    name: 'Nombres y apellidos',
  },
  {
    id: 'actividad1',
    name: 'A1',
  },
  {
    id: 'actividad2',
    name: 'A2',
  },
  {
    id: 'actividad3',
    name: 'A3',
  },
  {
    id: 'actividad4',
    name: 'A4',
  },
  {
    id: 'actividad5',
    name: 'A5',
  },
  {
    id: 'actividad6',
    name: 'A6',
  },
  {
    id: 'actividad7',
    name: 'A7',
  },
  {
    id: 'actividad8',
    name: 'A8',
  },
];

function getStyles(column, columnSelect, theme) {
  return {
    fontWeight:
      columnSelect.indexOf(column) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

// Create Document Component
const ReportesEstudiantes = () => {
  const theme = useTheme();
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const [loadingDoc, setLoadingDoc] = React.useState(true);
  const [columnSelect, setColumnSelects] = React.useState([
    'dni',
    'fullname',
    'actividad1',
    'actividad2',
    'actividad3',
    'actividad4',
    'actividad5',
    'actividad6',
    'actividad7',
    'actividad8',
  ]);

  const seccion = seccionesStore.all.find(
    (el) => el.id === estudiantesStore.params.idSeccion,
  );
  const titleSeccion = `${seccion.nivelAcademico.nivelAcademico.nombre} sección "${seccion.nombre}"`;

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setColumnSelects(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const select = (
    <FormControl fullWidth>
      <InputLabel id="reportes-estudiantes-label">
        Columnas a mostrar
      </InputLabel>
      <Select
        labelId="reportes-estudiantes-label"
        id="reportes-estudiantes"
        multiple
        value={columnSelect}
        onChange={handleChange}
        input={
          <OutlinedInput id="select-multiple-chip" label="Columnas a mostrar" />
        }
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value) => {
              const item = columnsReportesEstudiantes.find(
                (column) => column.id === value,
              );
              return <Chip key={item.id} label={item.name} />;
            })}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {columnsReportesEstudiantes.map((column) => (
          <MenuItem
            key={column.id}
            value={column.id}
            style={getStyles(column.id, columnSelect, theme)}
          >
            {column.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {select}
      </Grid>
      <Grid item md={12}>
        <PDFViewer style={styles.pdfViewer} showToolbar={true}>
          <Document
            title={`Reporte de estudiantes de ${titleSeccion}`}
            onRender={() => setLoadingDoc(false)}
          >
            <Page size="A4" style={stylesDocPdf.page}>
              <View style={styles.section}>
                <HeaderPdf entidad={entidadesStore.activo} />
                <TablaReportesEstudiantes
                  data={estudiantesStore.all}
                  columnSelect={columnSelect}
                  title={`Reporte de estudiantes de ${titleSeccion}`}
                />
              </View>
            </Page>
          </Document>
        </PDFViewer>
      </Grid>
      <Modal open={loadingDoc}>
        <Box sx={{ width: '100%' }}>
          <Typography variant="h6" sx={{ textAlign: 'center' }}>
            Generando reporte...
          </Typography>
          <LinearProgress />
          {/* <Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              Procesando la cantidad {estudiantesStore.all.length} estudiantes
            </Typography> */}
          <Typography sx={{ textAlign: 'center' }}>
            Este proceso puede que tarde entre 1 a 3 minutos para completa, por
            favor espere.
          </Typography>
        </Box>
      </Modal>
    </Grid>
  );
};

export default ReportesEstudiantes;
